import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { CancelBatchParticipationBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const cancelEducationalAdvisorBatchParticipation = createApiThunk<void, CancelBatchParticipationBody>(
  "educationalAdvisor/cancelBatchParticipation",
  async (command, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.cancelParticipation(command);
  },
);

export const resetCancelEducationalAdvisorBatchParticipation = createAction("educationalAdvisor/resetCancelBatchParticipation");
